<template>
    <div :class="component.classes">
        <component v-for="component in component.children" :is="component.type" :component="component"></component>
    </div>
</template>

<script>
  export default {
    name: 'ColumnsContainer',
    props: ['component', 'prop2'],
    data () {
      return {
        model: webase.model
      }
    },
    mounted () {
    },
    methods: {
      importantMethodHere () {
      }
    }
  }
</script>
